import { createSelector } from 'reselect';
import currentSessionSelector from './currentSession';

const allSessionSelector = state => state.restricted._session.session_proxy;

export default createSelector(
  allSessionSelector,
  currentSessionSelector,
  (sessions, currentSession) => sessions[currentSession]
);



// WEBPACK FOOTER //
// ./src/selectors/currentSessionObj.js